import { useQuery } from 'react-query'
import hooks from '../../../hooks'

const useReports = () => {
    const cacheKeys = hooks.useCacheKeys()
    const { api, endpoints } = hooks.useApi()
    const { data, isLoading } = useQuery(
        cacheKeys.REPORTS,
        () => api.get(endpoints.reports)
    )
    return {
        isLoading,
        reports: data || []
    }
}

export default useReports
